export const notesLoading =  ({store})  => store.notesReducer.loading;

export const notesError =  ({store})  => store.notesReducer.error;

export const notesData =  ({store})  => store.notesReducer.data;